import React, {Component, useContext, useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import { Button, ButtonCancel, ButtonModify, ButtonProceed, ButtonReturn } from '../../../../components/buttons';
import { Layout, MinMaxLayout, SeventyThirtyLayout, SixtyFourtyLayout } from '../../../../layouts';
import Welcome from '../../../../layouts/welcome';
import Row from '../../../../components/row';
import Container from '../../../../layouts/containers/container';
import List from '../../../../components/list';
import ContainerTable from '../../../../layouts/containers/container-table';
import InputsCheckbox from '../../../../components/inputs/inputs-checkbox';
import LabelContainer from '../../../../components/label-container';
import _ from 'lodash';
import membershipsApi from '../../../../lib/memberships/memberships-api';
import Blurred from '../../../../components/blurred';
import MediaHelper from '../../../../lib/helpers/media';
import companiesApi from '../../../../lib/companies/companies-api';

import { toast } from 'react-toastify';
import PopupContext from '../../../../context/context-popup';
import PopupsPurchase from '../../popups/poups-purchase';
import { FormatMonths } from '../../../../lib/helpers';
import BillingDetails from '../../../../components/billing-profile';
import ErrorContainer from '../../../../components/error-container';

const Summary = ({
    membership
}) => {
    const data = []

    data.unshift([
        1,
        membership?.name,
        `£${membership?.monthly_price}`
    ])

    return (
        <ContainerTable
            showMobileColumns
            headerColor="rgb(146, 155, 168)"
            valueColor="black"
            className="table-bookings"
            columns={[
                { field: 'QTY', width: '25%' },
                { field: 'Item', width: '50%' },
                { field: 'Price', width: '25%' },
            ]}
            data={[
                ...data
            ]}
        />
    )
}

const Purchase = ({ company, quote, setErrors, membershipId }) => {
    const { setPopup } = useContext(PopupContext);

    const hasAMembership = company?.company_memberships?.length > 0;

    const addMembership = () => {
        companiesApi.addMembership(window.user.company_id, {
            membership_id: membershipId,
        }, (errors) => {
            setErrors(errors)

            toast.error(Object.values(errors)?.join(' - '), {
                position: toast.POSITION.TOP_RIGHT
            });
        }).then(() => {
            window.location.href = `/mydmc/account/memberships`;
        });
    }

    const purchase = () => {
       if (hasAMembership) {
            return setPopup(<PopupsPurchase quote={quote} confirm={addMembership}/>);
        }

        addMembership();
    }

    return <ButtonModify onClick={purchase}>Purchase</ButtonModify>;
}

class MembershipBook extends Component {
    static contextType = PopupContext;

    constructor(props) {
        super(props);

        this.state = {
           params: {},
           membership: null,
           agree: false,
           quote: null,
           company: null,
           errors: {}
        }
    }

    componentDidMount() {
        this.getMembership();
        this.getCompany();
    }

    getMembership() {
        membershipsApi.getMembership(this.props.id).then(({ data }) => {
            this.setState({ membership: data }, () => {
                this.getQuote();
            });
        });
    }

    getQuote() {
        companiesApi.quoteMembership(window.user.company_id, {
            membership_id: this.props.id
        }).then(({ data }) => {
            this.setState({ quote: data })
        });
    }

    getCompany() {
        companiesApi.getCompany(window.user.company_id).then(({ data }) => {
            this.setState({ company: data })
        });
    }

    getFeaturedImage() {
        const image = this.state.membership?.content?.feature_image?.[0];

        if (image?.file_name === undefined) return '/images/office.png';

        return MediaHelper.formatPublicPath(`/images/${image?.file_name}`);
    }

    setErrors(errors) {
        this.setstate({ errors });

        if (errors?.booker_id !== undefined) {
            const details = document.querySelector('.billing-details');

            if (details) details.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    render() {
        if (this.state.membership === null) return null;

        return (
            <Layout 
            theme="light"
            topLeft={<Welcome title="Membership Purchase" subtitle={this.state.membership?.name}/>}
            topRight={
                <Row gap="20px">
                    <ButtonReturn>Cancel</ButtonReturn>
                </Row>
            }
        >
            <MinMaxLayout
                main={
                    <div className="booking-view">
                        <List gap="40px" className="booking-view__child">
                            <Container>
                                <Container.Header>
                                    <Container.Text color="#FF6933" fontSize="18px">Confirm Details</Container.Text>
                                </Container.Header>

                                <Container.Content> 
                                    <List gap="40px">
                                        <div className="booking-view__image" style={{ backgroundImage: `url('${this.getFeaturedImage()}')` }}></div>

                                        <LabelContainer label='Membership Plan'>
                                            { this.state.membership?.name }
                                        </LabelContainer>

                                        <LabelContainer label="Renewal">
                                            every { FormatMonths(this.state.membership?.renewal_interval_month) }
                                        </LabelContainer>

                                        <LabelContainer label='Cost'>
                                            £{ this.state.membership?.monthly_price }
                                        </LabelContainer>

                                        <LabelContainer label='Whats Included'>
                                            <ul style={{
                                                paddingLeft: '20px',
                                            }}>
                                                { this.state.membership?.content?.features?.map((feature, index) => {
                                                    return <li key={index}>{ feature ?.name }</li>
                                                }) }
                                            </ul>
                                        </LabelContainer>
                                    </List>
                                </Container.Content>
                            </Container>

                            <ErrorContainer errors={this.state.errors?.booker_id !== undefined ? ['You have not setup a billing profile yet'] : null}>
                                <BillingDetails/>
                            </ErrorContainer>
                        </List>

                        <Container className="booking-view__child">
                            <Container.Header>
                                <Container.Text color="#FF6933" fontSize="18px">Summary</Container.Text>
                            </Container.Header>

                            <Container.Content>
                                <List gap="40px">
                                    <Summary
                                        membership={this.state.membership}
                                    />

                                    <div className="agree-box">
                                        <InputsCheckbox
                                            text="I have read and agree to the booking terms and conditions"
                                            checked={this.state.agree}
                                            onChange={(e) => this.setState({ agree: e.value })}
                                        />
                                        <div className="agree-box__content">
                                            <div className="agree-box__details">
                                                <div className="agree-box-details__detail">
                                                    <p>Total</p>
                                                    <span>£{ this.state.membership?.monthly_price }</span>
                                                </div>
                                            </div>

                                            <Blurred toggled={!this.state.agree}>
                                                <Purchase 
                                                    company={this.state.company}
                                                    quote={this.state.quote} 
                                                    setErrors={this.setErrors.bind(this)} 
                                                    membershipId={this.props.id}
                                                />
                                            </Blurred>
                                        </div>
                                    </div>

                                    <Container>
                                        <Container.Header>
                                            <Container.Text fontSize="18px" color="#FF6933">Description</Container.Text>
                                        </Container.Header>

                                        <Container.Content>
                                            <Container.Text fontSize="14px" color="#24191F" html={this.state.membership?.description}></Container.Text>
                                        </Container.Content>
                                    </Container>

                                    <Container>
                                        <Container.Header>
                                            <Container.Text fontSize="18px" color="#FF6933">Contact Us</Container.Text>
                                        </Container.Header>

                                        <Container.Content>
                                            <Container.Text fontSize="14px" color="#24191F" style={{ whiteSpace: 'pre' }}>
                                                +44 (0)1226 720 700

                                                bookings@barnsleydmc.co.uk

                                                DMC
                                                County Way
                                                Barnsley
                                                S70 2JW
                                                UK
                                            </Container.Text>
                                        </Container.Content>
                                    </Container>
                                </List>
                            </Container.Content>
                        </Container>
                    </div>
                }
            />
        </Layout>    
        )
    }
}

const el = document.getElementById('account-memberships-book');

if (el) {
    ReactDOM.render(<MembershipBook id={el.getAttribute('data-id')}/> , el);
}
